import joinUrl from 'url-join';

function isDebugMode(env: { DEBUG_MODE?: string }): boolean {
  return !!env.DEBUG_MODE;
}

// eslint-disable-next-line
const currentEnv: any = process.env;
const isDebug: boolean = isDebugMode(currentEnv);

const formatBaseUrl = isDebug
  ? 'https://devc.litecdn.com'
  : currentEnv.FORMAT_BASE_URL || 'http://localhost:9494';

// Update the variable envAllowedList in webpack-utils.js when we add a new variable
const envVars = {
  SDK3_BROWSER_URL: joinUrl(formatBaseUrl, '/formats/browser-sdk3/index.js'),
  FORMAT_BASE_URL: formatBaseUrl,
  SENTRY_URL_UNIVERSAL_FORMATS: currentEnv.SENTRY_URL_UNIVERSAL_FORMATS,
  SENTRY_URL_VIDEO_FORMATS: currentEnv.SENTRY_URL_VIDEO_FORMATS,
  SENTRY_URL_CLIENT_SCRIPTS: currentEnv.SENTRY_URL_CLIENT_SCRIPTS,
  COMMIT_HASH: currentEnv.COMMIT_HASH || 'local',
  CURRENT_VERSION: currentEnv.CURRENT_VERSION || 'v3.0.0-local',
  INHOUSE_OMID_URL: joinUrl(
    formatBaseUrl,
    '/formats/omid-verification-client/index.js'
  ),
  ENV: currentEnv.ENV || 'local',
  FORMAT_ANALYTICS_ENDPOINT: isDebug
    ? 'https://ms-ads-events.devc.cloud.ogury.io'
    : currentEnv.FORMAT_ANALYTICS_ENDPOINT || 'http://localhost:3010/',
  MS_ADS_MONITORING_EVENTS_URL: isDebug
    ? 'https://ms-ads-monitoring-events.devc.cloud.ogury.io'
    : currentEnv.MS_ADS_MONITORING_EVENTS_URL ||
      'https://ads-monitoring-events.local.cloud.ogury.io',

  MS_ADS_HOST: currentEnv.MS_ADS_HOST || 'http://localhost:3088',
  MS_ADS_URL: currentEnv.MS_ADS_URL || 'https://ms-ads.devc.cloud.ogury.io',
  MS_ADS_EVENTS_HOST: currentEnv.MS_ADS_EVENTS_HOST || 'http://localhost:3089',
  NODE_ENV: currentEnv.NODE_ENV,
  VIDEO_TRACKING_URL: currentEnv.VIDEO_TRACKING_URL,
  OPT_OUT_SITE_URL: currentEnv.OPT_OUT_SITE_URL || 'https://privacy.ogury.com/',
  OPT_OUT_URL: 'https://pr-v1.presage.io/v1/presage',
  OPT_OUT_URL_TEST: currentEnv.ENV
    ? 'http://pr-v1.' + currentEnv.ENV + '.cloud.ogury.io/v1/presage'
    : 'http://pr-v1.deva.cloud.ogury.io/v1/presage',
  INJECT_SCRIPT_RETRY: 3,
  INJECT_SCRIPT_RETRY_DELAY: 100,
  PRESAGE_URL: currentEnv.PRESAGE_URL || 'http://localhost:3011',
  WSBACK_URL: currentEnv.WSBACK_URL || 'http://localhost:3012',
  JEST_TIMEOUT_FORMAT_COMPILATION: 400000,
  JEST_TIMEOUT_UNIT_TEST: 15000
};

// Override urls for tests
if (currentEnv.NODE_ENV === 'test') {
  envVars.WSBACK_URL = 'http://localhost:3012';
  envVars.PRESAGE_URL = 'http://localhost:3011';
  envVars.FORMAT_BASE_URL = 'http://localhost:9494';
  envVars.FORMAT_ANALYTICS_ENDPOINT = 'http://localhost:3010';
}

// to work with sentry, even in local, uncomment this lines :
// envVars.SENTRY_URL_UNIVERSAL_FORMATS =
//   'https://657550c5dd1a4a34bdb0b7470677d79e@sentry.io/1250247';
// envVars.SENTRY_URL_VIDEO_FORMATS =
//   'https://e26964fe89e742b0bb09fbdc2209594e@sentry.io/1464570';
// envVars.SENTRY_URL_CLIENT_SCRIPTS =
//   'https://de677ce8cdd6476eb1393e376361f1fb@sentry.io/1250250';

export default envVars;
